// Which step of the Connected Sales Lifecycle a document is at — from the
// document's OWN paperwork as well as its deal's stage, and never behind the
// paperwork (client, 2026-10-28: an invoiced quotation showed "Quotation"
// because the bar read only the deal, and 167 invoiced quotations have none).
//   0 Enquiry / Lead · 1 Sample / Trial · 2 Quotation · 3 Proforma / Neg. · 4 Order / Won
// Won is only when the order is dispatched — the deal reaches Closed Won then.

const STAGE_STEP: Record<string, number> = {
  new_lead: 0, contacted: 0, qualified: 0, requirement_received: 0,
  sample_trial: 1, trial_successful: 1, trial_unsuccessful: 1,
  quotation_sent: 2, follow_up: 2,
  negotiation: 3, po_expected: 3,
  order_confirmed: 4, production: 4, dispatch: 4, payment_pending: 4, closed_won: 4,
};

/** Older / free-text stage names, matched loosely as before. */
function legacyStageStep(s: string): number | null {
  if (s.includes('won')) return 4;
  if (s.includes('proforma') || s.includes('negotiat')) return 3;
  if (s.includes('quotation') || s.includes('proposal')) return 2;
  if (s.includes('sample') || s.includes('trial')) return 1;
  if (s.includes('lead') || s.includes('contacted') || s.includes('discovery')) return 0;
  return null;
}

const ORDER_STATUSES = ['invoiced', 'fulfilled', 'paid', 'partially_paid'];

export interface LifecycleStep {
  /** -1 = lost */
  index: number;
  won: boolean;
  /** Label for the last step: "Won", "Order confirmed", or the neutral "Order / Won". */
  lastLabel: string;
}

export function lifecycleStep({ documentType, documentStatus, dealStage }: { documentType: string; documentStatus?: string; dealStage?: string }): LifecycleStep {
  const stage = String(dealStage || '').toLowerCase();
  if (stage === 'closed_lost' || documentStatus === 'cancelled') return { index: -1, won: false, lastLabel: 'Order / Won' };

  // What the paperwork itself says.
  let docIndex = 0;
  if (['sales_order', 'direct_sale', 'delivery_challan'].includes(documentType) || ORDER_STATUSES.includes(String(documentStatus))) docIndex = 4;
  else if (documentType === 'proforma' || ['confirmed', 'accepted'].includes(String(documentStatus))) docIndex = 3;
  else if (documentType === 'quotation') docIndex = 2;
  else if (documentType === 'sample') docIndex = 1;

  const stageIndex = stage ? (STAGE_STEP[stage] ?? legacyStageStep(stage)) : null;
  const index = Math.max(docIndex, stageIndex ?? -1);
  const won = stage === 'closed_won';
  return { index, won, lastLabel: won ? 'Won' : index === 4 ? 'Order confirmed' : 'Order / Won' };
}
